<template>
  <span v-if="jlIsMobile" class="jl-mobile-column-move">
    <el-button type="text" icon="el-icon-arrow-up" :disabled="index === 0" aria-label="上移字段" @click.stop="$emit('move', index - 1)"></el-button>
    <el-button type="text" icon="el-icon-arrow-down" :disabled="index === count - 1" aria-label="下移字段" @click.stop="$emit('move', index + 1)"></el-button>
  </span>
</template>

<script>
import mobileViewport from '@/utils/mobileViewport'

export default {
  name: 'MobileColumnMove',
  mixins: [mobileViewport],
  props: {
    index: { type: Number, required: true },
    count: { type: Number, required: true }
  }
}
</script>

<style scoped>
.jl-mobile-column-move { display: inline-flex; flex-shrink: 0; gap: 4px; }
.jl-mobile-column-move .el-button { width: 44px; min-height: 44px; margin: 0; border: 1px solid #e5eaf2; border-radius: 8px; }
</style>



// WEBPACK FOOTER //
// src/components/MobileColumnMove/index.vue